export default class Aplicacion {
  constructor() {
    this.loading = new Boolean();
    this.config = new Object();
    this.cotas = new Boolean();
    this.seleccion = new Object();
    this.productoSel = new String();
    this.productos = new Array();
    this.getProducto = function (param) {
      var element = param == undefined ? (element = this.productoSel) : param;

      var filter = this.productos.find(
        (productoEl) => productoEl.cod == element
      );

      return filter != undefined ? filter : this.productos[0];
    };
  }
}
